import React from 'react';

import { BlockAdultsWithLowAssurance } from '@/components/block-adults-with-low-assurance';
import { AndroidWalletLowAssuranceWarning, GooglePayActivationForm } from '@/domain/digital-wallet';

export const AddToGoogleWalletPage = (): JSX.Element => {
    return (
        <div className="sgw-layout medium-centered-container">
            <div className="sgw-layout-item">
                <BlockAdultsWithLowAssurance
                    lowAssuranceWarning={<AndroidWalletLowAssuranceWarning />}
                    onlyNativeAllowedWarning={null!}
                >
                    <section className="google-wallet-page">
                        <GooglePayActivationForm />
                    </section>
                </BlockAdultsWithLowAssurance>
            </div>
        </div>
    );
};
